import "./components/styles/globals.scss";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./components/Home";
import Donations from "./components/Donations";
import Navbar from "./components/Navbar";
import Media from "./components/Media";
import About from "./components/About";
import Contact from "./components/Contact";
import AdvisoryBoard from "./components/AdvisoryBoard";
import Footer from "./components/Footer";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Faq from "./components/faq";
import SuccessStories from "./components/SuccessStories";
import Press from "./components/Press";
import ScrollProgress from "./components/ui/ScrollProgress";

// Reset scroll position to top whenever the route changes.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // When navigating to an in-page anchor (e.g. a success-story card),
    // let the target page handle scrolling instead of jumping to the top.
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollProgress />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Donations" element={<Donations />} />
        <Route path="/Media" element={<Media />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AdvisoryBoard" element={<AdvisoryBoard />} />
        <Route path="/Terms" element={<TermsOfService />} />
        <Route path="/Privacy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/press" element={<Press />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
